import { r as registerInstance, c as createEvent, g as getElement, h } from './core-39f715ab.js';
import { P as Popper } from './popper-2f5d1dc1.js';
var RaulMenu = /** @class */ (function () {
    function RaulMenu(hostRef) {
        registerInstance(this, hostRef);
        this.popper = null;
        this.dropdownId = "raul-dropdown-" + dropdownCount++;
        /**
         * Controls visibility of the menu.
         */
        this.open = false;
        /**
         * An array consisting of `MenuItemInterface`.
         */
        this.items = [];
        /**
         * Adds a space between final and previous menu items.
         */
        this.exclusive = false;
        /**
         * Menu items text size (sm = 12px, md = 14px).
         */
        this.textSize = "sm";
        /**
         * Enable or disable text-underline on hover over menu item.
         */
        this.textUnderline = true;
        /**
         * Type of variant for menu look.
         */
        this.variant = "links";
        /**
         * Enable or disable the border between menu items.
         */
        this.border = false;
        this.raulMenuClose = createEvent(this, "raulMenuClose", 7);
        this.raulMenuOpen = createEvent(this, "raulMenuOpen", 7);
        this.raulMenuClick = createEvent(this, "raulMenuClick", 7);
    }
    RaulMenu.prototype.componentDidUnload = function () {
        this.checkIfDropdownExists();
    };
    RaulMenu.prototype.handleClickWrapper = function (e) {
        this.open = !this.open;
        this.toggleMenuEl = e.target;
    };
    RaulMenu.prototype.handleOutsideClick = function (e) {
        var isClickOutsideMenu = !this.el.contains(e.target);
        var button = e.target.querySelector('button');
        var buttonNotDisabled = true;
        if (button) {
            buttonNotDisabled = !button.disabled;
        }
        if (this.open && isClickOutsideMenu && buttonNotDisabled) {
            this.open = false;
        }
    };
    RaulMenu.prototype.handleKeydown = function (e) {
        if (['Escape', 'Esc'].includes(e.key)) {
            this.open = false;
        }
        else if (['Tab'].includes(e.key) && this.open && this.items) {
            var btnIndex = +e.target.getAttribute('item-index'), lastItemIndex = this.items.length - 1;
            if (e.shiftKey && btnIndex === 0 || !e.shiftKey && btnIndex === lastItemIndex) {
                this.open = false;
            }
        }
    };
    RaulMenu.prototype.handleOpen = function () {
        this.open ? this.createDropdown() : this.destroyDropdown();
    };
    RaulMenu.prototype.checkIfDropdownExists = function () {
        var dropdownEl = document.getElementById(this.dropdownId);
        if (dropdownEl)
            dropdownEl.remove();
    };
    RaulMenu.prototype.createDropdown = function () {
        var _this = this;
        if (!this.popper) {
            document.body.appendChild(this.createDropdownElement());
            var dropdownRef_1 = this.dropdownRef();
            dropdownRef_1.items = this.items;
            dropdownRef_1.exclusive = this.exclusive;
            dropdownRef_1.textSize = this.textSize;
            dropdownRef_1.textUnderline = this.textUnderline;
            dropdownRef_1.border = this.border;
            dropdownRef_1.variant = this.variant;
            setTimeout(function () {
                _this.popper = new Popper(_this.el, dropdownRef_1, {
                    placement: 'bottom-start',
                    modifiers: {
                        offset: {
                            offset: "0, 10px"
                        },
                        computeStyle: {
                            gpuAcceleration: false
                        }
                    }
                });
                requestAnimationFrame(function () {
                    _this.dropdownRef().classList.add('r-menu-dropdown--open');
                });
            }, 50);
            this.raulMenuOpen.emit({ value: true });
            this.menuEl = document.getElementById(this.dropdownId);
            this.menuEl.addEventListener('raulMenuDropdownClick', function (e) {
                e.stopPropagation();
                _this.raulMenuClick.emit(e.detail);
            });
        }
    };
    RaulMenu.prototype.destroyDropdown = function () {
        var _this = this;
        if (this.popper) {
            this.dropdownRef().classList.remove('r-menu-dropdown--open');
            setTimeout(function () {
                _this.dropdownRef().parentNode.removeChild(_this.dropdownRef());
                _this.popper.destroy();
                _this.popper = null;
                _this.menuEl = null;
            }, 150);
            this.toggleMenuEl.focus();
            this.raulMenuClose.emit({ value: false });
        }
    };
    RaulMenu.prototype.dropdownRef = function () {
        return document.getElementById(this.dropdownId);
    };
    RaulMenu.prototype.createDropdownElement = function () {
        var dropDownEl = document.createElement('raul-menu-dropdown');
        dropDownEl.id = this.dropdownId;
        return dropDownEl;
    };
    Object.defineProperty(RaulMenu.prototype, "el", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RaulMenu, "watchers", {
        get: function () {
            return {
                "open": ["handleOpen"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RaulMenu, "style", {
        get: function () { return "raul-menu{display:inline-block}"; },
        enumerable: true,
        configurable: true
    });
    return RaulMenu;
}());
var dropdownCount = 0;
var RaulMenuDropdown = /** @class */ (function () {
    function RaulMenuDropdown(hostRef) {
        registerInstance(this, hostRef);
        this.items = null;
        this.exclusive = false;
        this.textSize = "sm";
        this.variant = "links";
        this.textUnderline = true;
        this.border = false;
        this.raulMenuDropdownClick = createEvent(this, "raulMenuDropdownClick", 7);
    }
    RaulMenuDropdown.prototype.componentDidLoad = function () {
        if (this.componentEl)
            this.componentEl.focus();
    };
    RaulMenuDropdown.prototype.handleClick = function (e, item) {
        if (item.onClick)
            item.onClick(e);
        this.raulMenuDropdownClick.emit(item);
    };
    RaulMenuDropdown.prototype.render = function () {
        var _a;
        var _this = this;
        var renderSpacer = function (exclusive, lastItem) {
            return exclusive && lastItem && h("div", { class: "r-menu-dropdown__spacer" });
        };
        var renderItem = function (item, index) {
            var _a;
            var Tag = item.url ? 'a' : 'button';
            return (h(Tag, { href: item.url ? item.url : null, id: "r-menu-dropdown__button-" + index, class: (_a = {
                        'r-menu-dropdown__button': true,
                        'r-menu-dropdown__button--disabled': item.disabled,
                        'r-menu-dropdown__button--destructive': item.destructive,
                        'r-menu-dropdown__button--underline': _this.textUnderline,
                        'r-menu-dropdown__button--border': _this.border
                    },
                    // [`r-text-${this.textColor}`]: true,
                    _a["r-text-" + _this.textSize] = true,
                    _a), "aria-label": item.value ? item.value : item.text, disabled: item.url ? null : item.disabled, title: item.text, "item-index": index, onClick: function (e) { return _this.handleClick(e, item); } }, item.icon &&
                h("raul-icon", { icon: item.icon }), item.text));
        };
        return (this.items &&
            h("div", { class: (_a = {
                        'r-menu-dropdown': true
                    },
                    _a["r-menu-dropdown--" + this.variant] = true,
                    _a), tabindex: "0", ref: function (el) { return _this.componentEl = el; } }, this.items.map(function (eachItems, index) { return h("div", { class: {
                    'r-menu-dropdown__item': true,
                    'r-menu-dropdown__item--border': _this.border,
                } }, renderSpacer(_this.exclusive, index === _this.items.length - 1), renderItem(eachItems, index)); })));
    };
    Object.defineProperty(RaulMenuDropdown, "style", {
        get: function () { return "raul-menu-dropdown{position:fixed;top:0;left:0;z-index:999999}raul-menu-dropdown,raul-menu-dropdown .r-menu-dropdown{opacity:0;-webkit-transition:opacity .15s linear;transition:opacity .15s linear}raul-menu-dropdown .r-menu-dropdown{border-radius:.125rem;-webkit-box-shadow:0 8px 16px 0 rgba(82,97,115,.18);box-shadow:0 8px 16px 0 rgba(82,97,115,.18);--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}raul-menu-dropdown .r-menu-dropdown--links{padding-top:.5rem;padding-bottom:.5rem}raul-menu-dropdown .r-menu-dropdown--links .r-menu-dropdown__item{--text-opacity:1;color:#0076cc;color:rgba(0,118,204,var(--text-opacity))}raul-menu-dropdown .r-menu-dropdown--items .r-menu-dropdown__item{padding-top:.25rem;padding-bottom:.25rem;--text-opacity:1;color:#202737;color:rgba(32,39,55,var(--text-opacity))}body[modality=keyboard] raul-menu-dropdown .r-menu-dropdown--items .r-menu-dropdown__button:focus{outline:none}body[modality=keyboard] raul-menu-dropdown .r-menu-dropdown--items .r-menu-dropdown__button:focus raul-icon{--text-opacity:1;color:#0076cc;color:rgba(0,118,204,var(--text-opacity))}body[modality=keyboard] raul-menu-dropdown .r-menu-dropdown:focus{outline:none}body[modality=keyboard] raul-menu-dropdown .r-menu-dropdown .r-menu-dropdown__item:focus{outline:1px solid #0076cc}raul-menu-dropdown .r-menu-dropdown .r-menu-dropdown__item--border{border-width:1px;border-left-width:0;border-right-width:0;border-top-width:0;--border-opacity:1;border-color:#ebedee;border-color:rgba(235,237,238,var(--border-opacity))}raul-menu-dropdown .r-menu-dropdown .r-menu-dropdown__item--border:last-child{border-bottom-width:0}raul-menu-dropdown .r-menu-dropdown__button{padding-left:1rem;padding-right:1rem;width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;text-align:left;position:relative;display:block;line-height:2rem}raul-menu-dropdown .r-menu-dropdown__button--destructive{--text-opacity:1;color:#d01a1f;color:rgba(208,26,31,var(--text-opacity))}raul-menu-dropdown .r-menu-dropdown__button--disabled{--text-opacity:1;color:#9ba3a7;color:rgba(155,163,167,var(--text-opacity));pointer-events:none}raul-menu-dropdown .r-menu-dropdown__button--icon raul-icon{padding-right:.5rem}raul-menu-dropdown .r-menu-dropdown__button--underline:hover{text-decoration:underline}body[modality=keyboard] raul-menu-dropdown .r-menu-dropdown__button:focus{outline:1px solid #0076cc}raul-menu-dropdown .r-menu-dropdown__button raul-icon{margin-right:.5rem;margin-top:-2px;font-size:inherit}raul-menu-dropdown .r-menu-dropdown__spacer:before{border-top-width:1px;--border-opacity:1;border-color:#f7f8f9;border-color:rgba(247,248,249,var(--border-opacity));content:\"\";display:block;width:100%;margin-top:8px;margin-bottom:8px}raul-menu-dropdown.r-menu-dropdown--open,raul-menu-dropdown.r-menu-dropdown--open .r-menu-dropdown{opacity:1}"; },
        enumerable: true,
        configurable: true
    });
    return RaulMenuDropdown;
}());
export { RaulMenu as raul_menu, RaulMenuDropdown as raul_menu_dropdown };
